import axios from 'axios';
import { getToken, removeUserSession } from '../../utils/user-session';
import { LOGIN_PAGE_ROUTE } from '../../constants';

const axiosPrivate = axios.create({
  headers: {
    "Content-Type": "application/json",
    "x-request-origin": "socios"
  }
});

axiosPrivate.interceptors.request.use(
  async (config) => {
    const token = getToken();

    if (token !== null) {
      config.headers = {
        ...config.headers, "Authorization": `Bearer ${token}`
      }
    }

    return config;
  },
  async (error) => await Promise.reject(error)
);

// Handle 401 Unauthorized responses (expired token)
axiosPrivate.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      removeUserSession();
      // Force full page reload to reset React state
      window.location.href = LOGIN_PAGE_ROUTE;
    }
    
    return Promise.reject(error);
  }
);

export default axiosPrivate;
